import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useStore } from "~/hooks/useStore";
import RootStore from "~/store/RootStore";
import ROUTES from "~/utils/routes";

export const useAppointmentSteps = () => {
  const store: RootStore = useStore();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const currentStepIdx = store.appointmentStepsStore.currentStep;

  const currentProgressPercent =
    store.appointmentStepsStore.currentProgressPercent;
  const currentProgressStep = store.appointmentStepsStore.currentProgressStep;

  const stepsTitles = store.cityStore.isMoscowRegion
    ? ["Выбор специальности и врача", "Выбор больницы", "Выбор времени приема"]
    : ["Выбор больницы", "Выбор специальности и врача", "Выбор времени приема"];

  const steps = store.appointmentStepsStore.steps.map((step, index) => ({
    ...step,
    title: stepsTitles[index],
  }));

  const currentStep = steps.find((_, idx) => idx === currentStepIdx);

  const navigationIndexes: Record<number, string> = {
    0: store.cityStore.isMoscowRegion
      ? ROUTES.SPECIALTIES.PATHNAME
      : ROUTES.HOSPITALS.PATHNAME,
    1: store.cityStore.isMoscowRegion
      ? ROUTES.HOSPITALS.PATHNAME
      : ROUTES.SPECIALTIES.PATHNAME,
    2: ROUTES.DATES.PATHNAME,
  };

  const setCurrentStep = useCallback(
    (stepIndex: number) => {
      store.appointmentStepsStore.setCurrentStep(stepIndex);
    },
    [store.appointmentStepsStore]
  );

  const recalculateStepsStatusBasedOnRoutes = (redirectTo: string) => {
    switch (redirectTo) {
      case ROUTES.HOSPITALS.PATHNAME:
        store.appointmentStepsStore.setCurrentStepForDisabling(
          store.cityStore.isMoscowRegion ? 1 : 0
        );
        break;
      case ROUTES.DOCTORS.PATHNAME:
      case ROUTES.SPECIALTIES.PATHNAME:
        store.appointmentStepsStore.setCurrentStepForDisabling(
          store.cityStore.isMoscowRegion ? 0 : 1
        );
        break;
      case ROUTES.DATES.PATHNAME:
        store.appointmentStepsStore.setCurrentStepForDisabling(2);
        break;
      default:
        break;
    }
  };

  const goToStep = (event: React.SyntheticEvent, newValue: number) => {
    navigate(navigationIndexes[newValue], { replace: true });
  };

  useEffect(() => {
    switch (pathname) {
      case ROUTES.HOSPITALS.PATHNAME:
        setCurrentStep(store.cityStore.isMoscowRegion ? 1 : 0);
        break;
      case ROUTES.DOCTORS.PATHNAME:
      case ROUTES.SPECIALTIES.PATHNAME:
        store.appointmentStepsStore.setCurrentStepRoute(pathname);
        setCurrentStep(store.cityStore.isMoscowRegion ? 0 : 1);
        break;
      case ROUTES.DATES.PATHNAME:
        setCurrentStep(2);
        break;
      default:
        break;
    }
  }, [
    pathname,
    navigate,
    setCurrentStep,
    store.appointmentStepsStore,
    store.cityStore.isMoscowRegion,
  ]);

  return {
    setCurrentStep,
    goToStep,
    currentStep,
    currentStepIdx,
    currentProgressPercent,
    currentProgressStep,
    recalculateStepsStatusBasedOnRoutes,
    steps,
  };
};
